export type IconType = "background" | "overlay" | "";

export type IconProps = {
	icon: IconType;
};

const getIconOthers = ({ icon }: IconProps) => {
	if (icon === "background") {
		return (
			<svg width="643" height="1116" viewBox="0 0 643 1116" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1055.06 756.999C1091.47 453.796 755.977 361.316 741.037 108.72C732.858 -29.5545 756.704 -311.423 274.805 -235.695C-36.1356 -185.677 -69.3547 113.282 136.324 384.179C183.925 465.906 184.086 536.265 161.896 616.14C139.705 696.014 3.68497 815.494 0.810518 1001.17C-7.83842 1559.94 918.694 1892.48 1055.06 756.999Z"
					fill="#63267B"
					fillOpacity="0.04"
				/>
			</svg>
		);
	}
	if (icon === "overlay") {
		return (
			<svg width="425" height="452" viewBox="0 0 425 452" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_1423_105168)">
					<path
						d="M377.284 343.986L377.276 344.19L387.246 452.001H314.493L305.063 385.786L300.912 450.303L226.201 449.454L234.137 364.75L240.886 325.488V325.48L241.899 319.571H375.3L375.474 321.711L377.284 343.986Z"
						fill="#2F2E41"
					/>
					<path
						d="M185.021 406.484C192.726 407.919 200.761 399.046 202.967 386.664C203.932 381.244 203.621 376.05 202.319 371.803L203.5 364.665L223.327 268.646C223.327 268.646 259.836 193.963 259.835 180.997C259.834 168.032 249.274 161.674 249.274 161.674L234.984 161.81L190.171 273.736L182.101 356.445L180.795 367.793C178.112 371.298 176.03 376.045 175.064 381.465C172.858 393.847 177.316 405.048 185.021 406.484V406.484Z"
						fill="#FFB6B6"
					/>
					<path d="M330.383 115.409L317.101 83.999L273.935 91.6392L271.029 128.593L330.383 115.409Z" fill="#FFB6B6" />
					<path opacity="0.1" d="M330.383 115.409L317.101 83.999L273.935 91.6392L271.029 128.593L330.383 115.409Z" fill="black" />
					<path
						d="M424.187 180.773C424.187 180.773 393.473 122.199 387.662 116.256C385.075 113.611 381.009 113.574 377.291 114.345L334.534 99.2783L320.041 90.9512L319.086 106.793L271.507 115.527C271.772 105.865 273.104 102.191 273.104 102.191L255.672 123.048L221.637 140.026L221.655 140.179C219.158 141.07 216.79 142.596 214.996 145.119C208.355 154.457 190.092 268.211 190.092 268.211L229.108 276.7L234.418 242.625L238.239 273.305L241.145 330.606C241.145 330.606 294.273 377.296 320.006 360.318C345.74 343.339 377.285 344.188 377.285 344.188L378.072 317.628C378.632 316.712 378.945 316.174 378.945 316.174L378.115 221.959V196.889C384.439 205.899 392.071 213.647 400.944 217.277C429.998 229.161 424.187 180.774 424.187 180.774V180.773Z"
						fill="#E6E6E6"
					/>
					<path
						d="M291.005 97.1653C312.937 97.1653 330.717 78.9834 330.717 56.5548C330.717 34.1263 312.937 15.9443 291.005 15.9443C269.073 15.9443 251.293 34.1263 251.293 56.5548C251.293 78.9834 269.073 97.1653 291.005 97.1653Z"
						fill="#FFB6B6"
					/>
					<path
						d="M319.495 68.0311C319.495 68.0311 322.948 55.6714 330.718 56.5542C338.488 57.4371 340.214 50.3744 338.488 46.843C336.761 43.3117 333.308 25.6549 333.308 25.6549C333.308 25.6549 335.035 13.2952 324.675 11.5295C314.315 9.76387 310.862 7.99819 309.135 4.46684C307.409 0.935492 281.51 -2.59586 272.877 2.70117C264.244 7.99819 257.337 18.1612 251.294 21.0253C245.251 23.8893 240.071 29.1863 243.524 38.0146C246.978 46.843 251.986 64.1094 251.986 64.1094C251.986 64.1094 260.791 60.9684 262.517 66.2654C264.244 71.5624 257.337 64.4997 265.97 50.3744C274.603 36.249 274.603 22.1236 288.416 27.4206C302.229 32.7176 317.769 30.9519 316.042 41.546C314.315 52.14 319.495 68.0311 319.495 68.0311V68.0311Z"
						fill="#2F2E41"
					/>
					<path
						d="M317.066 389.974H15.4679C6.93874 389.974 0 382.878 0 374.156V210.323C0 201.601 6.93874 194.505 15.4679 194.505H317.066C325.595 194.505 332.534 201.601 332.534 210.323V374.156C332.534 382.878 325.595 389.974 317.066 389.974Z"
						fill="white"
					/>
					<path
						d="M317.066 389.974H15.4679C6.93874 389.974 0 382.878 0 374.156V210.323C0 201.601 6.93874 194.505 15.4679 194.505H317.066C325.595 194.505 332.534 201.601 332.534 210.323V374.156C332.534 382.878 325.595 389.974 317.066 389.974V389.974ZM15.4679 197.146C8.36332 197.146 2.58303 203.057 2.58303 210.323V374.156C2.58303 381.422 8.36332 387.333 15.4679 387.333H317.066C324.171 387.333 329.951 381.422 329.951 374.156V210.323C329.951 203.057 324.171 197.146 317.066 197.146H15.4679Z"
						fill="#F3F6F9"
					/>
					<path
						d="M293.789 214.315C295.928 214.315 297.663 212.541 297.663 210.353C297.663 208.165 295.928 206.391 293.789 206.391C291.649 206.391 289.914 208.165 289.914 210.353C289.914 212.541 291.649 214.315 293.789 214.315Z"
						fill="#3F3D56"
					/>
					<path
						d="M304.121 214.315C306.26 214.315 307.995 212.541 307.995 210.353C307.995 208.165 306.26 206.391 304.121 206.391C301.981 206.391 300.246 208.165 300.246 210.353C300.246 212.541 301.981 214.315 304.121 214.315Z"
						fill="#3F3D56"
					/>
					<path
						d="M314.453 214.315C316.593 214.315 318.327 212.541 318.327 210.353C318.327 208.165 316.593 206.391 314.453 206.391C312.313 206.391 310.578 208.165 310.578 210.353C310.578 212.541 312.313 214.315 314.453 214.315Z"
						fill="#3F3D56"
					/>
					<path
						d="M21.9549 274.41C20.8866 274.41 20.0176 275.299 20.0176 276.391C20.0176 276.924 20.2188 277.417 20.5839 277.78C20.9522 278.166 21.4346 278.372 21.9549 278.372H311.869C312.937 278.372 313.806 277.484 313.806 276.391C313.806 275.859 313.605 275.366 313.24 275.002C312.871 274.617 312.389 274.41 311.869 274.41H21.9549Z"
						fill="#E6E6E6"
					/>
					<path
						d="M275.708 273.75V279.033H21.9561C21.2458 279.033 20.6 278.742 20.1351 278.254C19.6571 277.778 19.373 277.118 19.373 276.391C19.373 274.939 20.5354 273.75 21.9561 273.75H275.708Z"
						fill="#BA9FC5"
					/>
					<path
						d="M308.641 263.843H282.811C279.962 263.843 277.645 261.474 277.645 258.56C277.645 255.647 279.962 253.277 282.811 253.277H308.641C311.489 253.277 313.807 255.647 313.807 258.56C313.807 261.474 311.489 263.843 308.641 263.843Z"
						fill="#E6E6E6"
					/>
					<path
						d="M139.452 236.108H23.8926C21.0441 236.108 18.7266 233.739 18.7266 230.825C18.7266 227.911 21.0441 225.542 23.8926 225.542H139.452C142.301 225.542 144.618 227.911 144.618 230.825C144.618 233.739 142.301 236.108 139.452 236.108Z"
						fill="#E6E6E6"
					/>
					<path
						d="M21.9549 333.844C20.8866 333.844 20.0176 334.732 20.0176 335.825C20.0176 336.358 20.2188 336.85 20.5839 337.214C20.9522 337.6 21.4346 337.806 21.9549 337.806H311.869C312.937 337.806 313.806 336.917 313.806 335.825C313.806 335.292 313.605 334.799 313.24 334.436C312.871 334.05 312.389 333.844 311.869 333.844H21.9549Z"
						fill="#E6E6E6"
					/>
					<path
						d="M176.261 333.183V338.466H21.9561C21.2458 338.466 20.6 338.175 20.1351 337.686C19.6571 337.211 19.373 336.551 19.373 335.824C19.373 334.371 20.5354 333.183 21.9561 333.183H176.261Z"
						fill="#BA9FC5"
					/>
					<path
						d="M308.641 323.277H282.811C279.962 323.277 277.645 320.908 277.645 317.994C277.645 315.08 279.962 312.711 282.811 312.711H308.641C311.489 312.711 313.807 315.08 313.807 317.994C313.807 320.908 311.489 323.277 308.641 323.277Z"
						fill="#E6E6E6"
					/>
					<path
						d="M353.861 100.289C376.201 100.289 394.31 82.16 394.31 59.7964C394.31 37.4329 376.201 19.3037 353.861 19.3037C331.522 19.3037 313.412 37.4329 313.412 59.7964C313.412 82.16 331.522 100.289 353.861 100.289Z"
						fill="#63267B"
					/>
					<path
						d="M367.59 39.3711C362.205 49.3985 356.819 59.426 351.434 69.4535C348.002 63.2523 344.589 57.0401 341.148 50.8437C339.96 48.7036 336.728 50.6285 337.919 52.7738C341.908 59.9568 345.855 67.1637 349.843 74.3468C350.525 75.5749 352.397 75.6035 353.072 74.3468C358.988 63.3316 364.903 52.3164 370.819 41.3012C371.978 39.1428 368.75 37.211 367.59 39.3711V39.3711Z"
						fill="white"
					/>
					<path
						d="M409.699 166.532L369.399 146.818C369.399 146.818 367.78 133.623 360.222 128.916C358.938 125.782 357.459 122.338 356.117 119.609C352.796 112.862 357.777 100.128 353.626 100.128C349.476 100.128 343.34 113.52 343.665 117.106C343.914 119.859 346.139 124.665 346.599 128.873C341.537 130.825 337.454 134.171 334.77 136.835C332.446 139.14 331.583 142.58 332.491 145.757C335.122 154.965 341.699 173.983 351.136 173.983C363.588 173.983 366.908 171.436 366.908 171.436C366.908 171.436 392.642 204.544 411.735 207.09C430.828 209.637 409.699 166.532 409.699 166.532V166.532Z"
						fill="#FFB6B6"
					/>
				</g>
				<defs>
					<clipPath id="clip0_1423_105168">
						<rect width="424.661" height="452" fill="white" />
					</clipPath>
				</defs>
			</svg>
		);
	}
};

export default getIconOthers;
